<template lang="pug">
  .loading-continter
    .loading-block
      .card-list-item(v-for="(item,index) in cardList")
        .card-line-one
        .card-line-two
  </template>
<script>
export default {
  data() {
    return {
      cardList: [1, 2, 3, 4],
    };
  },
};
</script>
<style lang="less" scoped>
.loading-continter {
  background: #f3f4f6;
  height: 100vh;
  width: 100%;
  padding-top: 0.87rem;

  .loading-block {
    background: linear-gradient(180deg, #FFFFFF -6.92%, #F3F4F6 10.06%);
    height: 100%;
    padding: 0.17rem 0.12rem 0 0.12rem;

    .card-list-item {
      width: 100%;
      height: 1.31rem;
      background: #fff;
      border-radius: 0.16rem;
      padding: 0.15rem;
      margin-bottom: 0.08rem;
      position: relative;

      .card-line-one {
        width: 1.64rem;
        height: 0.3rem;
        background: #f5f5f5;
        margin-bottom: 0.08rem;
        border-radius: 0.08rem;
      }

      .card-line-one::before {
        content: '';
        z-index: 2;
        position: absolute;
        display: inline-block;
        left: 0;
        top: 0;
        width: 2rem;
        height: 1.31rem;
        transform: skewX(135deg);
        opacity: 0.5;
        background: linear-gradient(200deg, rgba(255, 255, 255, 0) 30.82%, #fff 45.23%, #fff 56.8%, rgba(255, 255, 255, 0) 70.24%);
        animation: move-light 1.5s both infinite;
      }

      .card-line-two {
        width: 100%;
        height: 0.2rem;
        background: #f5f5f5;
        border-radius: 0.08rem;
      }
    }
  }
}

@keyframes move-light {
  0% {
    left: -50%;
  }

  100% {
    left: 125%;
  }
}
</style>
